import { ReactElement, ReactNode, Suspense } from "react";
import PageLoadSkeleton from "./PageLoadSkeleton";

const Loader = ({
  children,
  variant = "form",
  element,
}: {
  children: ReactNode;
  variant?: "form" | "dashboard" | "search-with-table";
  element?: ReactElement | undefined;
}) => {
  return (
    <Suspense
      fallback={
        Boolean(element) ? element : <PageLoadSkeleton variant={variant} />
      }
    >
      {children}
    </Suspense>
  );
};

export default Loader;
